import constants from "../config/constants";
import _ from "lodash";

export const previewImageOfPost = (post) => {
  if (post?.referenceFiles) {
    return post && post?.referenceFiles.find(
      (f) => f.fileKey === constants.fileKey.previewImage && f.filePath
    );
  }
  return ''
};

/* param {value} [string] gets the form input value*/
/* return {sanitizedValue} [string] sanitizes the form input value*/
export const sanitizeFormInput = (value) => {
  let sanitizedValue = value || ''
  return (String(sanitizedValue).replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;')) || ''
};

export const isValidJSON = (json) => {
  try {
    JSON.parse(json);
    return true;
  } catch (e) {
    return false;
  }
}

export const mtStandardsBooks = (lookup, string) => {
  const lookUpMtStandardsBooks = lookup && lookup.find(function (v) { return v['key'] === string });
  return lookUpMtStandardsBooks?.children ? lookUpMtStandardsBooks?.children : []
}

export const appendEllipsis = (text) => {
  if (text.endsWith('.') || text.endsWith('..')) {
    return text;
  }
  return text + '...';
}

export const setPmbok7Link = (endpoints) => {
  const showPmbok7Link = (endpoints && endpoints?.pmbok7TocUrl !== undefined) &&
    (endpoints && endpoints?.pmbok7TocUrl !== '') &&
    (endpoints && (endpoints?.pmbok7TocUrl).indexOf('https') !== -1) ? true : false;
  return showPmbok7Link || false
}

export const getExcludeSearchKey = (filterGroup, appliedSearch, excludeValue) => {
  let excludedDefaultFilters = excludeValue;
  if (appliedSearch !== "") {
    return ''
  }
  if (filterGroup.length === 0) {
    return excludedDefaultFilters;
  } else {
    const mediaType = _.filter(filterGroup, { filterkey: "MediaType" });
    const mediaTypeFilters = mediaType[0]?.filtervalue || "";
    const excludeDefaults = excludedDefaultFilters && excludedDefaultFilters.split(',') || [];
    const selectedMediaType = mediaTypeFilters.split(',') || [];
    const excludeVal = _.differenceWith(excludeDefaults, selectedMediaType, _.isEqual);
    return excludeVal.join()
  }
}

export const getItemNames = (item) => {
  let itemNames = _.mapKeys(item, (value, key) => {
    switch (key) {
      case "parentcontentid":
        return "parentContentId";
      case "contentkey":
        return "contentKey";
      case "contenttypeid":
        return "contentType";
      case "pmapproach":
        return "pmApproach";
      case "isvisible":
        return "isVisible";
      case "ispublic":
        return "isPublic";
      case "datecreated":
        return "dateCreated";
      case "createdby":
        return "createdBy";
      case "lastupdated":
        return "lastUpdated";
      case "lastupdatedby":
        return "lastUpdatedBy";
      case "publisheddate":
        return "publicationDate";
      case "expirationdate":
        return "expirationDate";
      case "subtopic":
        return "subTopic";
      case "mediatype":
        return "mediaType";
      case "categories":
        return "category";
      case "imagepreview":
        return "previewImage";
      case "attributionsources":
        return "attributionSources";
      case "fullcontent":
        return "fullContent";
      case "subtitle":
        return "subTitle";
      default:
        return key;
    }
  });
  return itemNames;
}
